import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from 'react-bootstrap';
import {isEmpty} from 'lodash';

import './styles.scss';

const ErrorAlert = (props) => {
  const {
    error = false,
    errorStyle = 'danger',
    alertVisible,
    handleDismissAlert,
  } = props;

  if (!alertVisible) {
    return null;
  }

  let errorHtml = 'An unknown error occurred.';
  if (error && error.messages) {
    if (error.messages.length > 1) {
      errorHtml = (
        <ul>
          {error.messages.map((message, index) => (
            <li key={`error-message-${index}`}>{message.text}</li>
          ))}
        </ul>
      );
    } else if (error.messages.length) {
      errorHtml = (<div dangerouslySetInnerHTML={{__html: error.messages[0].text}} />);
    }
  }

  return (
    <Alert variant={errorStyle} className="error-alert" dismissible onClose={handleDismissAlert}>
      {error && error.messages && error.messages.length > 1 &&
        <h4>We encountered some errors.</h4>
      }
      {errorHtml}
    </Alert>
  );
};

ErrorAlert.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
  errorStyle: PropTypes.string,
  alertVisible: PropTypes.bool.isRequired,
  handleDismissAlert: PropTypes.func.isRequired,
};

export default ErrorAlert;
